<div class="container-admin">
  <form [formGroup]="passwordForm" class="main-content">
    <div class="form tpl-form-2">
      <div class="container-img">
        <img src="assets/image/logo-admin.svg" />
      </div>
      <h2>Plataforma OZ</h2>
      <h4 class="oz-login-subtitle">Admin</h4>

      <hr />

      <div class="content-login-admin">
        <h4 class="form-login-title">Cadastrar nova senha</h4>
        <div class="form-login-subtitle">
          Digite uma nova senha de 8 dígitos.
        </div>

        <div class="form-row">
          <div class="col-xl-12">
            <mat-form-field appearance="outline">
              <mat-label>Senha</mat-label>
              <input [type]="hide ? 'password' : 'text'"
              matInput
              formControlName="password" />
              <button
              type="button"
                class="eye-color"
                mat-icon-button
                matSuffix
                (click)="hide = !hide"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide"
              >
                <img
                  [src]="
                    hide
                      ? 'assets/image/eye-icon-open.svg'
                      : 'assets/image/eye-icon-close.svg'
                  "
                />
              </button>
              <mat-error
              class="mb-1"
              *ngIf="
              resetPassFormControl.password.touched &&
              resetPassFormControl.password.errors?.minlength
              "
            >
              Digite uma senha de no mínimo oito caracteres
            </mat-error>
              <mat-error
              class="mb-1"
              *ngIf="
              resetPassFormControl.password.touched &&
                resetPassFormControl.password.errors?.required
              "
            >
              Senha obrigatória
            </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-group mb-0">
          <button
            [ngClass]="{
              'btn-gray-disabled': passwordForm.invalid,
              'btn-dark-blue': !passwordForm.invalid
            }"
            [disabled]="passwordForm.invalid"
            class="btn btn-block mb-3"
            type="button"
            (click)="resetPassword()"
          >
            Entrar
            <span
              class="spinner-border spinner-border-sm"
              *ngIf="loading"
            ></span>
          </button>
        </div>

        <div (click)="goBack()" class="text-login">
          <p>Voltar ao login</p>
        </div>
      </div>
    </div>
  </form>
</div>

